import React from 'react';
import { useNavigate } from 'react-router-dom';
import toast from 'react-hot-toast';
import { AccordionItem, AccordionSubtitle, AccordionTitle, AccordionTrigger, AccordionContent } from '@/components/ui/accordion';
import { DGLesson, DGLessonCheck, DGLessonRow, DGLessonTd, DGLessonText, DGLessonTitle } from '@/components/custom/dg';

export function CourseModuleAboutAccordionItem({ module, currentModule, prevModule }) {
  const navigate = useNavigate();

  const amountLessons = module.learning_system_items.length;

  const formatDuration = seconds => {
    const hours = Math.floor(seconds / 3600);
    const minutes = Math.floor((seconds % 3600) / 60);
    const secondsLeft = seconds % 60;

    const parsedDuration = value => value.toString().padStart(2, '0');

    return `${parsedDuration(hours)}:${parsedDuration(minutes)}:${parsedDuration(secondsLeft)}`;
  };

  const checkPermission = (item, index, prevItem) => {
    if (index === 0 && prevModule === null) {
      navigate(`/show-course/${currentModule.id}/classroom/${item.id}`);
    } else if (index === 0) {
      const lastClass = prevModule?.learning_system_items[prevModule?.learning_system_items.length - 1];
      if (lastClass.unrequired === true) {
        navigate(`/show-course/${currentModule.id}/classroom/${item.id}`);
      } else if (lastClass.unrequired === false && lastClass.finished === true) {
        navigate(`/show-course/${currentModule.id}/classroom/${item.id}`);
      } else {
        toast.error('Você ainda não pode acessar essa aula!');
      }
    } else {
      if (prevItem.unrequired === true) {
        navigate(`/show-course/${currentModule.id}/classroom/${item.id}`);
      } else if (prevItem.unrequired === false && prevItem.finished === true) {
        navigate(`/show-course/${currentModule.id}/classroom/${item.id}`);
      } else {
        toast.error('Você ainda não pode acessar essa aula!');
      }
    }
  };

  return (
    <AccordionItem value={module.id}>
      <AccordionTrigger>
        <AccordionTitle>
          {module.body} {module.finished && <span className="badge badge--tiny badge--success">Concluído</span>}
        </AccordionTitle>
        <AccordionSubtitle>{amountLessons > 0 ? `${amountLessons} aulas` : 'Sem aulas'}</AccordionSubtitle>
      </AccordionTrigger>

      <AccordionContent>
        <DGLesson>
          {module.learning_system_items.map((item, i) => {
            const prevItem = i > 0 ? module.learning_system_items[i - 1] : null;

            return (
              <DGLessonRow
                key={item.id}
                onClick={() => checkPermission(item, i, prevItem)}
              >
                <DGLessonTd variant="title">
                  {/* Retornar se a aula está completa do backend */}
                  {item.finished && <DGLessonCheck isChecked />}

                  <DGLessonTitle title={item.body}>{item.body}</DGLessonTitle>
                </DGLessonTd>
                {/* O que é isso? */}
                {/* <DGLessonTd><DGLessonLink>Plano de aula</DGLessonLink></DGLessonTd> */}
                {/* Retornar quantidade de arquivos para cada aula do backend */}
                <DGLessonTd variant="files">
                  <DGLessonText>{item?.['learning-system-files-count']} arquivos</DGLessonText>
                </DGLessonTd>
                <DGLessonTd variant="time">
                  <DGLessonText>{item.duration !== 0 ? formatDuration(item.duration) : ''}</DGLessonText>
                </DGLessonTd>
              </DGLessonRow>
            );
          })}
        </DGLesson>
      </AccordionContent>
    </AccordionItem>
  );
}
